import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import OrderHistoryProp from '../propTypes/orderHistoryProp';
import ShopTimelineItem from './ShopTimelineItem';

function ShopTimelineStatus({ orderHistory, currency, isOpportunity }) {
  return (
    <div className="m-portlet__body">
      <div className="tab-content">
        <div className="tab-pane active show" id="m_widget4_tab1_content">
          <div
            className="m-scrollable m-scroller ps ps--active-y"
            data-scrollable="true"
            data-height="400"
          >
            <div className="m-list-timeline m-list-timeline--skin-light">
              <div className="m-list-timeline__items">
                {orderHistory?.map(history => (
                  <ShopTimelineItem
                    key={history._id}
                    currency={currency}
                    timelineItem={history}
                    isOpportunity={isOpportunity}
                  />
                ))}
              </div>
            </div>
            <div className="ps__rail-x">
              <div className="ps__thumb-x" />
            </div>
            <div className="ps__rail-y">
              <div className="ps__thumb-y" />
            </div>
          </div>
        </div>
        <div className="tab-pane" id="m_widget4_tab2_content" />
        <div className="tab-pane" id="m_widget4_tab3_content" />
      </div>
    </div>
  );
}

ShopTimelineStatus.propTypes = {
  orderHistory: PropTypes.arrayOf(PropTypes.shape(OrderHistoryProp.propType))
    .isRequired,
  currency: PropTypes.string.isRequired,
  isOpportunity: PropTypes.bool,
};

ShopTimelineStatus.defaultProps = {
  isOpportunity: false,
};

export default translate(ShopTimelineStatus);
